module.exports = __webpack_public_path__ + "img/machiine-more.f0db9a2d.jpg";